import { render, staticRenderFns } from "./VCases.vue?vue&type=template&id=315a5740&"
import script from "./VCases.vue?vue&type=script&lang=js&"
export * from "./VCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports